export enum CustomerSortType {
    Id,
    Name,
    Code,
    TaxNumber,
    TaxAdministration,
    IsDeleted,

    Logo
}
